<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch12"></a><a id="page_13"></a><a href="#/contents#ch12"><b>Random Thirteens</b></a></h2>
<p class="noindent"><span>The number 13 is considered lucky in China because its symbol resembles one that means “must be alive.”</span></p>
<p class="noindent"><span>In 1941, Joe DiMaggio struck out only 13 times. (In contrast, Phillies first baseman Ryan Howard struck out 199 times in 2007, the most on record.)</span></p>
<p class="noindent"><span>Napoléon Bonaparte, Herbert Hoover, and Franklin Delano Roosevelt all feared the number 13.</span></p>
<p class="noindent"><span>In 1959, Harvey Haddix became the first pitcher to throw 12 perfect innings—and then he lost the game in the 13th.</span></p>
<p class="noindent"><span><i>Apollo 13</i> was launched at 13:13, military time. The astronauts aborted the mission and turned back to Earth on Friday, April 13.</span></p>
<p class="noindent"><span>Black Sabbath released its self-titled first album in February 1970…on Friday the 13th.</span></p>
<p class="noindent"><span>Cost to U.S. economy when superstitious people stay home on Friday the 13th: $800 million.</span></p>
<p class="noindent"><span>Although DVDs are the same size as CDs, a DVD can store 13 times as much data.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter12.vue?38f2b260